const BRAND_PATTERN = /(WhatsApp|Instagram|Messenger|Facebook|FeedBot)/g;
const BRANDS = new Set(["WhatsApp", "Instagram", "Messenger", "Facebook", "FeedBot"]);

/** Keep English product and provider names in logical LTR order inside RTL copy. */
export function IsolatedBrands({ text }: { text: string }): React.JSX.Element {
  const parts = text.split(BRAND_PATTERN);
  return (
    <>
      {parts.map((part, index) =>
        BRANDS.has(part) ? (
          <bdi key={`${part}-${index}`}>{part}</bdi>
        ) : (
          <span key={`${index}-${part.slice(0, 12)}`}>{part}</span>
        ),
      )}
    </>
  );
}
